import { render, staticRenderFns } from "./ProjectTutorial.vue?vue&type=template&id=b5109850&"
import script from "./ProjectTutorial.vue?vue&type=script&lang=js&"
export * from "./ProjectTutorial.vue?vue&type=script&lang=js&"
import style0 from "./ProjectTutorial.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports